import { render, staticRenderFns } from "./HomeSectionCelular.vue?vue&type=template&id=75752e5e&scoped=true&"
import script from "./HomeSectionCelular.vue?vue&type=script&lang=js&"
export * from "./HomeSectionCelular.vue?vue&type=script&lang=js&"
import style0 from "./HomeSectionCelular.vue?vue&type=style&index=0&id=75752e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75752e5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VImg,VProgressCircular,VRow})
